import { DisplayErrors } from "../../../../../Utils/ErrorHandler";
import { Translate } from "../../../../../Utils/TranslationUtils";
import useApi from "../../../../../Utils/BackendClient";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useIsMobile } from "../../../../../Utils/ResizeUtils";
import { useLocation, useNavigate } from "react-router-dom";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../../CommonStyles.module.css";
import { Button } from "primereact/button";

const OlxPlugin = () => {

    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef();

    const { fetchOlxAdvertrs, fetchPluginDetails, OlxLogin, updatePluginSettings } = useApi();

    const [isLoginned, setIsLogined] = useState(false);
    const [pluginDetails, setPluginDetails] = useState({
        settings: []
    });
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);

    const menuItems = [
        {
            label: "Оголошення",
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            }
        },
        {
            label: "Налаштування",
            icon: 'pi pi-cog',
            command: () => {
                getPluginDetails();
                setTabShowed(1);
            }
        }
    ]

useEffect(() => {

     const login = async () => {
        const loginResponse = await OlxLogin();

        console.log("loginResponse", loginResponse);

        if (loginResponse.status === 200) {
            setIsLogined(true);
        } else {
            DisplayErrors(loginResponse.error, toast);
        }
    };

    const fetchAdverts = async () => {
        const response = await fetchOlxAdvertrs();

        console.log("adverts response", response);

        if(response.status === 401){
            const lgResponse = await login();

            if(lgResponse.status === 200)
            {
                console.log(lgResponse);
            }
        }
    };

    fetchAdverts();

}, [isLoginned, fetchOlxAdvertrs, OlxLogin]);

    const confirmLeave = (event) => {

        if (formik.values !== pluginDetails) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate("/marketplace") }
            });

        }
        else {
            navigate("/marketplace");
        }
    }

    const getPluginDetails = async () => {
        if (location.state?.pluginName) {
            const response = await fetchPluginDetails(location.state.pluginName);

            console.log(response.status);
            if (response.status === 200) {
                setPluginDetails(response.data);
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
        else{
            toast.current.show( )
        }
    };

    const formik = useFormik({
        initialValues: pluginDetails,
        enableReinitialize: true,
        validate: values => {
            const errors = {};
            return errors;
        },
        onSubmit: async (values) => {
            setSubmitLoading(true);

            const payload = {
                plugin_name: values.plugin_name,
                is_enabled: values.is_enabled,
                settings: values.settings
            }

            const response = await updatePluginSettings(payload);

            if(response.status === 200){
                navigate("/marketplace");
            }
            else{
                DisplayErrors(response.error, toast);
            }

            setSubmitLoading(false);
        }
    });

    const mainToolbarRightTemplate = () => {
        return <>
            <div className="flex flex-wrap gap-2">
                <Button icon={`${isMobile ? "pi pi-save" : ""}`} label={`${isMobile ? "" : "Зберегти"}`} severity="success" loading={submitLoading} className={commonStyle.addButton} type="submit" />
                <Button icon={`${isMobile ? "pi pi-sign-out" : ""}`} label={`${isMobile ? "" : "Вийти"}`} severity="secondary" className={commonStyle.closeButton} type="button" onClick={confirmLeave} />
            </div>
        </>;
    }

    const toolbarLeftData = () => {
        return !isMobile ? <h3>{"Деталі плагіну"}</h3> : null;
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Toast ref={toast} />
            <Toolbar className="mb-4" start={toolbarLeftData} end={mainToolbarRightTemplate} />
            <ConfirmDialog group="headless" />
            <TabMenu model={menuItems} />
            {tabShowed === 1 && <div className="grid">
                <div className={`${commonStyle.leftMenu} col-3`}>
                    {Object.entries(formik.values?.settings).map(([key, value]) => (
                        <div className={`${commonStyle.formInput}`} id={key}>
                            <div className="p-inputgroup flex-column">
                                <FloatLabel>
                                    <InputText
                                        id={key}
                                        value={value}
                                        onChange={(e) => formik.setFieldValue(`settings.${key}`, e.target.value)}
                                        className="w-full"
                                        autoFocus
                                    />
                                    <label>{Translate(key)}</label>
                                </FloatLabel>
                            </div>
                        </div>
                    ))}
                </div>
            </div>}
        </form>
    );

}

export default OlxPlugin;